"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlreadyRegistryError = exports.NoRegistryError = exports.NotfoundTypeError = exports.MultiImplementError = exports.IocContext = exports.DefaultRegisterOption = exports.Config = void 0;
var utils_1 = require("./utils");
var metadata_1 = require("./class/metadata");
var ClassLoader_1 = require("./class/ClassLoader");
var guard_1 = require("./utils/guard");
var aspect_1 = require("./decorator/aspect");
var Config = /** @class */ (function () {
    function Config() {
        /** auto register class self, when class not found. default: false */
        this.autoRegisterSelf = false;
        /** constructor inject, MUST in TypeScript with emitDecoratorMetadata and use decorator with class, default: true */
        this.constructorInject = true;
        /** use class loader for autowired default: true */
        this.useClassLoader = true;
    }
    return Config;
}());
exports.Config = Config;
exports.DefaultRegisterOption = {
    singleton: true,
    autoNew: true,
};
/** ioc context */
var IocContext = /** @class */ (function () {
    function IocContext(config) {
        if (config === void 0) { config = {}; }
        this.config = config;
        this.classLoader = ClassLoader_1.classLoader;
        this.components = new Map();
        this.config = Object.assign({}, new Config(), config);
        if (config.useClassLoader instanceof ClassLoader_1.ClassLoader) {
            this.classLoader = config.useClassLoader;
        }
    }
    Object.defineProperty(IocContext, "DefaultInstance", {
        get: function () {
            return (this.defaultInstance || ((this.defaultInstance = new IocContext()), this.defaultInstance));
        },
        enumerable: false,
        configurable: true
    });
    /**
     * merge config
     * @param config new partial config
     */
    IocContext.prototype.setConfig = function (config) {
        Object.assign(this.config, config);
    };
    /**
     * remove instance of key
     * @param keyOrType key
     */
    IocContext.prototype.remove = function (keyOrType) {
        var key = utils_1.getGlobalType(keyOrType);
        if (this.components.has(key)) {
            this.preDestroyInstance(this.components.get(key));
        }
        return this.components.delete(key);
    };
    /** clear all */
    IocContext.prototype.clear = function () {
        var _this = this;
        Array.from(this.components.values()).forEach(function (ele) {
            _this.preDestroyInstance(ele);
        });
        this.components.clear();
    };
    /**
     * get instance of key
     * @param keyOrType key
     * @param opt
     */
    IocContext.prototype.get = function (keyOrType, opt) {
        if (opt === void 0) { opt = {}; }
        var key = utils_1.getGlobalType(keyOrType);
        if (this.components.has(key)) {
            return this.returnValue(this.components.get(key), opt.forceNew);
        }
        if (this.config.notFoundHandler) {
            var data = this.config.notFoundHandler(keyOrType);
            if (data !== undefined) {
                return data;
            }
        }
        if (opt.useClassLoader || this.config.useClassLoader) {
            var type = keyOrType;
            var classes = this.classLoader.getImplementClasses(type);
            switch (classes.length) {
                case 1:
                    // class loader is only responsible for matching and not for registration.
                    return this.get(classes[0].type, opt);
                case 0:
                    break;
                default:
                    if (this.config.conflictHandler) {
                        var one = this.config.conflictHandler(type, classes, opt.sourceCls
                            ? {
                                type: opt.sourceCls,
                                info: ClassLoader_1.classLoader.getClassInfo(opt.sourceCls),
                            }
                            : undefined);
                        if (one !== undefined) {
                            // class loader is only responsible for matching and not for registration.
                            return this.get(one, opt);
                        }
                    }
                    // BaseClass has @injectable
                    if (utils_1.isClass(keyOrType) && metadata_1.getMetadata(type).injectable) {
                        this.register(type);
                        return this.get(type, opt);
                    }
                    throw new MultiImplementError(type, key);
            }
        }
        if (this.config.parentContext) {
            return this.config.parentContext.get(keyOrType);
        }
        var canAutoRegister = utils_1.isClass(keyOrType) &&
            (this.config.autoRegisterSelf || metadata_1.getMetadata(keyOrType).injectable);
        if (canAutoRegister) {
            this.register(keyOrType);
            return this.get(keyOrType, opt);
        }
        throw new NotfoundTypeError(keyOrType, key);
    };
    /**
     * get instances for key
     * @param keyOrType key (super class or interface, use `@classInfo`)
     * @param opt
     */
    IocContext.prototype.getImports = function (keyOrType, _a) {
        var _this = this;
        var cache = (_a === void 0 ? {} : _a).cache;
        var type = keyOrType;
        if (cache && this.has(type)) {
            return this.get(type);
        }
        var data = this.classLoader.getImplementClasses(type).map(function (clsInfo) {
            return _this.get(clsInfo.type, {
                useClassLoader: true,
            });
        });
        if (cache) {
            this.register(data, type);
        }
        return data;
    };
    /**
     * instance of key in context
     * @param keyOrType key
     */
    IocContext.prototype.has = function (keyOrType) {
        return this.components.has(utils_1.getGlobalType(keyOrType));
    };
    IocContext.prototype.replace = function (keyOrType, newData, options, registerIfNotExist) {
        if (registerIfNotExist === void 0) { registerIfNotExist = false; }
        var key = utils_1.getGlobalType(keyOrType);
        var data = this.components.get(key);
        if (data) {
            this.components.set(key, this.newStore(newData, options || data.options));
        }
        else if (registerIfNotExist) {
            this.register(newData, keyOrType, options);
        }
        else {
            throw new NoRegistryError(key);
        }
    };
    /**
     * register key
     * @param data value of key (maybe instance, class, factory function or value)
     * @param key key
     * @param options register option
     */
    IocContext.prototype.register = function (data, key, options) {
        if (options === void 0) { options = exports.DefaultRegisterOption; }
        if (key) {
            if (!this.canBeKey(key)) {
                throw new Error('key require string, symbol or class.');
            }
        }
        else {
            if (!this.canBeKey(data)) {
                throw new Error('when data is not string, symbol or class, require a key.');
            }
        }
        var dataType = (key && utils_1.getGlobalType(key)) || (data && utils_1.getGlobalType(data));
        if (this.components.has(dataType)) {
            throw new AlreadyRegistryError(dataType);
        }
        options = __assign(__assign({}, exports.DefaultRegisterOption), options);
        var store = this.newStore(data, options);
        this.components.set(dataType, store);
    };
    /**
     * complete instance inject
     * @param instance
     * @param opt
     */
    IocContext.prototype.inject = function (instance, opt) {
        var _this = this;
        if (opt === void 0) { opt = {
            autoRunPostConstruct: true,
        }; }
        var iocSelf = this;
        var classType = instance.constructor;
        metadata_1.getMetadataField(classType, 'injects').forEach(function (inject) {
            var key = inject.key, typeCls = inject.typeCls, optional = inject.optional, singleton = inject.singleton;
            var descriptor = Object.getOwnPropertyDescriptor(instance, key);
            var defaultValue = descriptor && descriptor.value;
            var allowOptional = optional || defaultValue !== undefined;
            if ('inject' === inject.type) {
                Object.defineProperty(instance, key, {
                    configurable: true,
                    writable: true,
                    value: guard_1.guard(function () {
                        return _this.get(typeCls, __assign({ sourceCls: classType }, (singleton ? {} : { forceNew: true })));
                    }, {
                        defaultValue: defaultValue,
                        onError: function (err) {
                            if (!allowOptional) {
                                err.message += "\n\tSource: " + classType.name + "." + key.toString();
                                throw err;
                            }
                        },
                    }),
                });
            }
            if (['lazyInject', 'imports'].includes(inject.type)) {
                var always_1 = inject.always;
                Object.defineProperty(instance, key, {
                    configurable: true,
                    get: function () {
                        var hasErr = false;
                        var data = guard_1.guard(function () {
                            switch (inject.type) {
                                case 'lazyInject':
                                    return iocSelf.get(typeCls, __assign({ sourceCls: classType }, (singleton ? {} : { forceNew: true })));
                                case 'imports':
                                    return iocSelf.getImports(typeCls, { cache: !always_1 });
                            }
                        }, {
                            defaultValue: defaultValue,
                            onError: function (err) {
                                hasErr = true;
                                if (!allowOptional) {
                                    err.message += "\n\tSource: " + classType.name + "." + key.toString();
                                    throw err;
                                }
                            },
                        });
                        if (!hasErr && !always_1) {
                            Object.defineProperty(this, key, {
                                configurable: true,
                                writable: true,
                                value: data,
                            });
                        }
                        return data;
                    },
                    set: function (value) {
                        Object.defineProperty(this, key, {
                            configurable: true,
                            writable: true,
                            value: value,
                        });
                    },
                });
            }
        });
        metadata_1.getMetadataField(classType, 'aspects').forEach(function (aspect) {
            var oriFn = instance[aspect.key];
            var newFn = aspect_1.genAspectWrapper(_this, aspect.point, oriFn);
            Object.defineProperty(instance, aspect.key, {
                configurable: true,
                value: newFn,
            });
        });
        if (opt.autoRunPostConstruct) {
            this.runPostConstruct(instance);
        }
    };
    IocContext.prototype.runPostConstruct = function (instance) {
        var classType = instance.constructor;
        Array.from(new Set(metadata_1.getMetadataField(classType, 'postConstruct').map(function (p) { return p.key; }))).forEach(function (key) {
            instance[key]();
        });
    };
    /**
     * create child context, inherit this context
     * @param config
     */
    IocContext.prototype.createChildContext = function (config) {
        return new IocContext(__assign(__assign(__assign({}, this.config), (config || {})), { parentContext: this }));
    };
    /**
     * run preDestroy method of instance
     * @param store instance store
     */
    IocContext.prototype.preDestroyInstance = function (store) {
        if (!store.inited) {
            return;
        }
        var inst = store.value;
        Array.from(new Set(metadata_1.getMetadataField(inst.constructor, 'preDestroy').map(function (p) { return p.key; }))).forEach(function (key) {
            inst[key]();
        });
    };
    IocContext.prototype.newStore = function (data, options) {
        var _this = this;
        var dataIsFunction = typeof data === 'function';
        var dataIsClass = dataIsFunction && utils_1.isClass(data);
        var needFactory = dataIsFunction && options.autoNew;
        return {
            inited: needFactory ? false : true,
            factory: needFactory
                ? function () {
                    if (dataIsClass) {
                        var ClsType_1 = data;
                        var args = [];
                        if (_this.config.constructorInject && Reflect && Reflect.getMetadata) {
                            var paramTypes = Reflect.getMetadata('design:paramtypes', ClsType_1);
                            if (paramTypes) {
                                args = paramTypes.map(function (type) {
                                    if (type === ClsType_1 ||
                                        type === undefined ||
                                        type === null ||
                                        type === Number ||
                                        type === Error ||
                                        type === Object ||
                                        type === String ||
                                        type === Boolean ||
                                        type === Array ||
                                        type === Function) {
                                        return null;
                                    }
                                    return _this.get(type);
                                });
                            }
                        }
                        var value = new (ClsType_1.bind.apply(ClsType_1, __spreadArrays([void 0], args)))();
                        _this.inject(value);
                        return _this.config.createInstanceHook
                            ? _this.config.createInstanceHook(value, _this)
                            : value;
                    }
                    else {
                        var func = data;
                        return func(_this);
                    }
                }
                : undefined,
            value: needFactory ? undefined : data,
            options: options,
        };
    };
    IocContext.prototype.canBeKey = function (obj) {
        var type = typeof obj;
        // ie11 symbol is object
        if (type === 'object') {
            return obj.toString() !== '[object Object]';
        }
        return ['function', 'string', 'symbol'].includes(type);
    };
    IocContext.prototype.returnValue = function (data, forceNew) {
        if (forceNew === void 0) { forceNew = false; }
        if (data.options.singleton && !forceNew) {
            return data.inited
                ? data.value
                : ((data.inited = true), (data.value = data.factory()), data.value);
        }
        else {
            // TODO use WeakMap collection for destroy
            return data.factory();
        }
    };
    IocContext.prototype.toJSON = function () {
        return { type: 'power-di.IocContext', message: 'NoSerializable' };
    };
    return IocContext;
}());
exports.IocContext = IocContext;
var MultiImplementError = /** @class */ (function (_super) {
    __extends(MultiImplementError, _super);
    function MultiImplementError(type, key) {
        return _super.call(this, "Has multi Classes of implement type: " + type.name + "(" + utils_1.symbolString(key) + ")") || this;
    }
    return MultiImplementError;
}(Error));
exports.MultiImplementError = MultiImplementError;
var NotfoundTypeError = /** @class */ (function (_super) {
    __extends(NotfoundTypeError, _super);
    function NotfoundTypeError(type, key) {
        return _super.call(this, "Notfound type: " + (type.name || type) + "(" + utils_1.symbolString(key) + ")") || this;
    }
    return NotfoundTypeError;
}(Error));
exports.NotfoundTypeError = NotfoundTypeError;
var NoRegistryError = /** @class */ (function (_super) {
    __extends(NoRegistryError, _super);
    function NoRegistryError(key) {
        return _super.call(this, "the key:[" + utils_1.symbolString(key) + "] is no registry.") || this;
    }
    return NoRegistryError;
}(Error));
exports.NoRegistryError = NoRegistryError;
var AlreadyRegistryError = /** @class */ (function (_super) {
    __extends(AlreadyRegistryError, _super);
    function AlreadyRegistryError(key) {
        return _super.call(this, "the key:[" + utils_1.symbolString(key) + "] is already registry.") || this;
    }
    return AlreadyRegistryError;
}(Error));
exports.AlreadyRegistryError = AlreadyRegistryError;
//# sourceMappingURL=IocContext.js.map